<div id="disqus_thread"></div>

<script>
  import { afterUpdate } from 'svelte';
  export let identifier = null;
  /**
  *  RECOMMENDED CONFIGURATION VARIABLES: EDIT AND UNCOMMENT THE SECTION BELOW TO INSERT DYNAMIC VALUES FROM YOUR PLATFORM OR CMS.
  *  LEARN WHY DEFINING THESE VARIABLES IS IMPORTANT: https://disqus.com/admin/universalcode/#configuration-variables*/

  var disqus_config = function () {
    this.page.url = 'https://d-ns.studio';  // Replace PAGE_URL with your page's canonical URL variable
    this.page.identifier = 'session_' + identifier; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
  };

  afterUpdate(() =>{
    if (identifier !== null) {
      (function() {
        var d = document, s = d.createElement('script');
        s.src = 'https://d-ns-studio.disqus.com/embed.js';
        s.setAttribute('data-timestamp', +new Date());
        (d.head || d.body).appendChild(s);
      })();
    }
  });
</script>
